import type { TFunction } from "i18next";

import { parseListValue } from "./conditions";
import { getOperatorPhrase } from "./operatorLabels";
import type { FormCondition } from "./schemas";

import { OperatorValue } from "@/config/operatorConfig";
import type {
  ConditionBadgeParts,
  SegmentField,
} from "@/features/segments/types";

const listValues = ({
  operator,
  values,
}: FormCondition): string[] | undefined => {
  if (operator === OperatorValue.IN) return parseListValue(values[0]);
  if (operator === OperatorValue.IS_ANY_OF) return values;
  return undefined;
};

export const formatConditionValue = (condition: FormCondition): string =>
  (listValues(condition) ?? condition.values).join(", ");

export const formatConditionBadge = (
  condition: FormCondition,
  fields: SegmentField[],
  t: TFunction,
): ConditionBadgeParts | undefined => {
  if (!condition.field) return undefined;
  const catalogueField = fields.find(
    (candidate) => candidate.value === condition.field,
  );
  const field = catalogueField?.label ?? condition.field;
  if (!condition.operator) return { field, markExcluded: condition.isInverted };
  const phrase = getOperatorPhrase(t, condition.operator, condition.isInverted);
  const operatorParts = {
    field,
    operator: phrase.text,
    markExcluded: condition.isInverted && !phrase.isNegated,
  };
  if (condition.operator === OperatorValue.IS_NULL) return operatorParts;
  return {
    ...operatorParts,
    value: listValues(condition) ?? condition.values.join(", "),
  };
};
